const states = new Set('AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO'.split(' '));
const text = value => String(value ?? '').trim();
const normalized = value => text(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export const balcaoAddressState = value => states.has(text(value).toUpperCase()) ? text(value).toUpperCase() : '';
export const balcaoOriginAddress = context => context?.originVerified === true && context?.origin
  && text(context?.address?.city) && balcaoAddressState(context?.address?.state)
  ? { city: text(context.address.city), state: balcaoAddressState(context.address.state) } : null;
export const applyBalcaoAddressDefaults = (address = {}, defaults, { stateHint = false } = {}) => {
  const city = text(address.city) || text(defaults?.city);
  const state = stateHint ? '' : balcaoAddressState(address.state);
  return { ...address, city, state: state || (city && normalized(city) === normalized(defaults?.city)
    ? balcaoAddressState(defaults?.state) : '') };
};
export const mergeBalcaoResolvedAddress = (current = {}, canonical = {}, { placePoint = false } = {}) => ({
  ...current,
  ...Object.fromEntries(['street', 'number', 'neighborhood', 'city'].map(field => [field, placePoint ? text(canonical[field]) : text(canonical[field]) || text(current[field])])),
  state: balcaoAddressState(canonical.state) || balcaoAddressState(current.state),
  cep: text(canonical.cep ?? canonical.postalCode ?? current.cep).replace(/\D/g, ''),
  // Reference and instructions are the operator's current intent, never geocoder output.
  reference: current.reference || '', notes: current.notes || '',
});
